export const errorHandler = () => {
        import('sweetalert2').then(module => module.default.fire({
            title : 'Server Issue!',
            text : 'Seems issue on our end, please try again later.',
            icon : 'error'
        }))
}